/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { withInstance } from 'fierry/react';

import Client from 'fierry/rpc/client';

import Snapshot from 'fierry/rpc/snapshot';


const Context = withInstance(Client);

const ClientExport = Context.Export;


Context.Export = ({ as, children, ...props }) =>
(
  <ClientExport {...props}>
    <Snapshot Rpc = {Context} as = {as} children = {children} />
  </ClientExport>
);


export default Context;
